export default "__VITE_ASSET__d50bf1cc__"